import { faShieldCheck } from '@awesome.me/kit-4a6bf60416/icons/classic/solid';

import { Icon } from '@/components/ui/icon';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

export function VerifiedBadge({ className }: { className?: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-default items-center">
          <Icon icon={faShieldCheck} className={cn('size-[10px] text-blue-600', className)} />
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[220px] text-center text-xs leading-5">
        This review was submitted by a verified client and has not been modified.
      </TooltipContent>
    </Tooltip>
  );
}
